import { useEffect, useRef } from 'react';
import { USER_BLOCKED_EVENT } from '../utils/cacheInvalidation';

/**
 * Calls `onBlocked(userId)` whenever the viewer blocks someone, from any
 * surface (notifyUserBlocked). A list uses it to drop the blocked person's
 * cards (dropCardsFromUser). The latest callback is read through a ref, so a
 * caller need not memoize it.
 */
export default function useDropBlockedUser(onBlocked) {
  const onBlockedRef = useRef(onBlocked);
  onBlockedRef.current = onBlocked;
  useEffect(() => {
    const handler = (event) => {
      const userId = event?.detail?.userId;
      if (userId != null && onBlockedRef.current) onBlockedRef.current(userId);
    };
    window.addEventListener(USER_BLOCKED_EVENT, handler);
    return () => window.removeEventListener(USER_BLOCKED_EVENT, handler);
  }, []);
}
